import { Div, Label, Touchable } from "@grassrootly/rn-core";
import { useState } from "react";
import { Modal, ScrollView } from "react-native";
import { ISeason } from "@grassrootly/api";

interface SeasonSelectorProps {
  seasons: ISeason[];
  selectedSeasonId: number | null;
  onSeasonSelected: (seasonId: number) => void;
  compact?: boolean;
}

export default function SeasonSelector({ seasons, selectedSeasonId, onSeasonSelected, compact = false }: SeasonSelectorProps) {
  const [isPickerVisible, setIsPickerVisible] = useState(false);

  const selectedSeason = seasons.find((s) => s.id === selectedSeasonId);

  const handleSeasonSelect = (seasonId: number) => {
    onSeasonSelected(seasonId);
    setIsPickerVisible(false);
  };

  return (
    <>
      <Touchable
        classNames={[
          "flexRow",
          "alignItemsCenter",
          compact ? "justifyContentCenter" : "justifyContentSpaceBetween",
          "bgSecondaryMain",
          "br-{8}",
          compact ? "ph-{12}" : "p-{12}",
          compact ? "pv-{6}" : "",
        ]}
        onPress={() => setIsPickerVisible(true)}
      >
        {!compact && (
          <Label type="l3Regular" classNames={["colorSecondaryLight"]}>
            Season:
          </Label>
        )}
        <Div classNames={["flexRow", "alignItemsCenter"]}>
          <Label type={compact ? "l4Regular" : "l2Regular"} classNames={["mr-{4}"]}>
            {selectedSeason?.name || "Select Season"}
          </Label>
          <Label type={compact ? "l4Regular" : "l2Regular"}>▼</Label>
        </Div>
      </Touchable>

      {/* Season Picker Modal */}
      <Modal visible={isPickerVisible} transparent animationType="fade" onRequestClose={() => setIsPickerVisible(false)}>
        <Touchable
          classNames={["flex1", "bgColor-{rgba(0,0,0,0.5)}", "justifyContentCenter", "alignItemsCenter"]}
          onPress={() => setIsPickerVisible(false)}
        >
          <Div classNames={["bgNeutralDarkerDark", "br-{12}", "p-{16}", "w-{80%}", "maxH-{400}"]}>
            <Label type="l1Bold" classNames={["mb-{16}", "textCenter"]}>
              Select Season
            </Label>
            <ScrollView>
              {seasons.map((season) => (
                <Touchable
                  key={season.id}
                  classNames={[
                    "p-{12}",
                    "br-{8}",
                    "mv-{4}",
                    season.id === selectedSeasonId ? "bgPrimaryMain" : "bgSecondaryMain",
                  ]}
                  onPress={() => handleSeasonSelect(season.id)}
                >
                  <Label
                    type="l2Regular"
                    classNames={[season.id === selectedSeasonId ? "colorNeutralLighterLight" : ""]}
                  >
                    {season.name}
                    {season.is_active ? " (Active)" : ""}
                  </Label>
                </Touchable>
              ))}
            </ScrollView>
          </Div>
        </Touchable>
      </Modal>
    </>
  );
}
